const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the notifications edit component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {MicrosoftTeams} MicrosoftTeams the resource defined to manage MicrosoftTeams
 */
app.directive('microsoftProfileIntegration', ['Application', 'Authorization', 'MicrosoftTeams', function (Application, Authorization, MicrosoftTeams) {
    return {
      restrict: 'E',
      template: require('../../templates/directives/microsoft-profile-integration.html'),
      controller: ['$scope', function ($scope) {
        const self = this;
        self.user = Authorization.getAuthToken().user;
        self.integrated = false;
        self.redirectDomain = Application.companyDomain === 'staging.continu.co' ? 'learn.continu.co' : Application.companyDomain;

        self.integration = {
          link: Application.microsoftTeamsLink.replace('{STATE}', self.redirectDomain),
          remove: async function() {
            try {
              await MicrosoftTeams.removeIntegration();
              self.integrated = false;
            } catch (e) {
              console.error('Error removing Microsoft Teams Integration: ', e);
              Application.messaging.addMessage({type: 'error', text: 'Error removing Microsoft Teams Integration', duration: 5});
              return;
            }
            Application.messaging.addMessage({type: 'success', text: 'Removed Microsoft Teams Integration', duration: 5});
          }
        };


        self.initialize = async function () {
          const results = await MicrosoftTeams.checkExists({userId: self.user._id.toString()}).$promise;
          self.integrated = results.microsoftTeamsExists;
        }
        self.initialize();
      },
    ],
      controllerAs: 'msProfileIntegration'
    }
  }]);



